import { joinUrlSegments } from './utils.js';
export class HttpFetchClient {
  baseUrl;
  defaultHeaders;
  interceptor;
  constructor(baseUrl = '', defaultHeaders = {}, interceptor = (r) => r) {
    this.baseUrl = baseUrl;
    this.defaultHeaders = defaultHeaders;
    this.interceptor = interceptor;
  }
  getBaseUrl() {
    return this.baseUrl;
  }
  getCurrentHeaders() {
    return { ...this.defaultHeaders };
  }
  setBaseUrl(baseUrl) {
    this.baseUrl = baseUrl;
    return this;
  }
  setDefaultHeaders(headers) {
    this.defaultHeaders = { ...headers };
  }
  useInterceptor(interceptor) {
    this.interceptor = interceptor;
  }
  async request(url, options) {
    const fullUrl = this.baseUrl ? joinUrlSegments(this.baseUrl, url) : url;
    const { url: intercepted_url, options: intercepted_options } = this.interceptor({
      url: fullUrl,
      options: {
        ...options,
        headers: {
          ...(options.headers ?? {}),
          ...this.defaultHeaders,
        },
      },
    });
    try {
      const response = await fetch(intercepted_url, intercepted_options);
      const status = response.status;
      const message = response.statusText;
      // 2xx OK
      if (response.ok) {
        return {
          ok: true,
          status,
          data: await response.json(),
        };
      }
      // else
      const data = await response.json();
      return {
        ok: false,
        data,
        status,
        message,
      };
    } catch (error) {
      console.error('Fetch error:', error);
      throw error;
    }
  }
  async get(url, headers = this.defaultHeaders) {
    return this.request(url, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        ...headers,
      },
    });
  }
  async post(url, body, headers = this.defaultHeaders) {
    return this.request(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        ...headers,
      },
      body,
    });
  }
  async put(url, body, headers = this.defaultHeaders) {
    return this.request(url, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        ...headers,
      },
      body,
    });
  }
  async delete(url, headers = this.defaultHeaders) {
    return this.request(url, {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
        ...headers,
      },
    });
  }
  async patch(url, body, headers = this.defaultHeaders) {
    return this.request(url, {
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json',
        ...headers,
      },
      body,
    });
  }
}
